import * as angular from "angular";
import {IController} from 'angular';
import * as _ from "lodash";
import {ServiceAreasServiceType} from "../../angular/types/service-areas-service.type";

export class serviceAreasMultiSelectCtrl implements IController {

  serviceAreas: any[];
  selectedIds: any;
  branchIds: any[];
  serviceTypes: ServiceAreasServiceType[];
  options: any;
  optionIds: any;
  ngPlaceholder: any;
  excludeIds: any;
  isDisabled: any;
  onChange: Function;

  private serviceAreasRef: any;
  public selectedServiceAreas: any;
  public selectedText: any;

  /* @ngInject */
  constructor(private $mdPanel, private $serviceArea, private $element) {
    this.serviceAreasRef = this.$serviceArea();
  }

  $onInit() {
    this._setSelectedServiceAreas();
  };

  $onChanges(changes) {
    if (changes.serviceAreas && !changes.serviceAreas.isFirstChange()){
      this._setSelectedServiceAreas();
    }
    if (changes.selectedIds && !changes.selectedIds.isFirstChange()){
      this._setSelectedServiceAreas();
    }
  };


  onShowPanel($event) {

    if (!!this.isDisabled) {
      return;
    }

    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.CENTER,
        this.$mdPanel.yPosition.BELOW // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.bringoz-select-input')
      .withAnimation(this.$mdPanel.animation.FADE);

    const selectedIdsRef = (this.selectedIds ? this.selectedIds : (!!this.serviceAreas ? _.map(this.serviceAreas, 'id') : []));
    const optionsRef = this.options;
    const optionIdsRef = this.optionIds;
    const excludeIdsRef = this.excludeIds;
    const ngPlaceholderRef = this.ngPlaceholder;
    const branchIdsRef = this.branchIds;
    const serviceTypesRef = this.serviceTypes;

    const config = {
      attachTo: angular.element(document.body),
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: '<bringoz-multi-select-filter-panel ' +
        'type="ctrl.typeRef" ' +
        'selected-ids="ctrl.selectedIdsRef" ' +
        'options="ctrl.optionsRef" ' +
        'option-ids="ctrl.optionIdsRef" ' +
        'ng-placeholder="ctrl.ngPlaceholderRef" ' +
        'panel-ref="ctrl.mdPanelRef" ' +
        'query-map="ctrl.queryMapRef" ' +
        'service-areas-types="ctrl.serviceTypesRef" ' +
        'exclude-ids="ctrl.excludeIdsRef">' +
        '</bringoz-multi-select-filter-panel>',
      controller: function () {
        this.typeRef = 'serviceAreas';
        this.selectedIdsRef = selectedIdsRef;
        this.optionsRef = optionsRef;
        this.optionIdsRef = optionIdsRef;
        this.ngPlaceholderRef = ngPlaceholderRef;
        this.excludeIdsRef = excludeIdsRef;
        this.serviceTypesRef = serviceTypesRef;
        this.queryMapRef = {
          branchIds: branchIdsRef
        }
      },
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: (panel, selectedIds) => {
        if (selectedIds === 'clickOutsideToClose' || selectedIds === 'escapeToClose') {
          selectedIds = selectedIdsRef;
        }

        if (!selectedIds?.length) {
          this.onChange({serviceAreas: [], ids: []});
          panel.destroy();
        } else {
          if (!!this.options) {
            const serviceAreas = _.filter(this.options, (o) => {
              return _.includes(selectedIds, o.id);
            });
            this.onChange({serviceAreas: serviceAreas, ids: selectedIds});
            panel.destroy();
          } else {
            this.serviceAreasRef.$asyncValues(selectedIds)
              .then((serviceAreas) => {
                this.onChange({serviceAreas: serviceAreas, ids: selectedIds});
                panel.destroy();
              });
          }
        }
      }
    };

    this.$mdPanel.open(config);
  }

  onResetFilter() {
    this.onChange({ids: [], serviceAreas: []});
  }

  private _setSelectedServiceAreas() {
    if (!!this.serviceAreas) {
      this.selectedServiceAreas = angular.copy(this.serviceAreas);
    } else if (!!this.selectedIds) {
      if (!!this.options) {
        this.selectedServiceAreas = _.filter(this.options, (o) => {
          return _.includes(this.selectedIds, o.id);
        });
        this._setSelectedText();
      } else {
        this.serviceAreasRef.$asyncValues(this.selectedIds)
          .then((serviceAreas) => {
            this.selectedServiceAreas = _.orderBy(serviceAreas, ['name'], ['asc']);
            this._setSelectedText();
          })
      }
    } else {
      this.selectedServiceAreas = [];
      this._setSelectedText();
    }
  }

  private _setSelectedText() {
    let string = '';
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext("2d");

    _.forEach(this.selectedServiceAreas, (b, i) => {
      string += b.areaName;
      if ((i + 1) < this.selectedServiceAreas.length) {
        string += ', '
      }
    });

    var stringWidth = ctx.measureText(string).width;
    if (this.$element[0]?.clientWidth && (stringWidth + 80) >= (this.$element[0].clientWidth - 30)) {
      string = this.selectedServiceAreas[0].areaName + ` +${this.selectedServiceAreas.length - 1}`
    }
    this.selectedText = string;
  }


}

angular
  .module('bringoz.admin.service-areas')
  .component('serviceAreasMultiSelect', {
    bindings: {
      serviceAreas: '<?',
      selectedIds: '<?',
      branchIds: '<?',
      serviceTypes: '<?',
      options: '<?',
      optionIds: '<?',
      ngPlaceholder: '@?',
      excludeIds: '<?',
      isDisabled: '<?',
      onChange: '&'
    },
    template: require('./service-areas-multi-select.html').default,
    controller: serviceAreasMultiSelectCtrl
  });
